// ============================
// Application Configuration
// ============================

const host = typeof window !== "undefined" ? window.location.hostname : "";
const isProdHost = host === "srskannan.com" || host === "www.srskannan.com";

const defaultWpBaseUrl = isProdHost
  ? "https://api.srskannan.com"
  : "https://betaapi.srskannan.com";

const config = {
  API_BASE_URL: process.env.REACT_APP_API_BASE_URL || `${defaultWpBaseUrl}/wp-json`,
  WP_BASE_URL: process.env.REACT_APP_WP_BASE_URL || defaultWpBaseUrl,
};

export default config;
